<template>
    <div class="header">
        <div class="wrap">
        <div class="logo"><a href="/"></a></div>
        <div class="hdnav">
            <a :class="item.url === $route.path?'active':''" v-for="(item,index) in footerList" :key="index" :href="item.url">
<!--                <i :class="'icon'+index"><em v-if="index === 4 && notice>0"></em></i>-->
                <span>{{item.name}}</span>
            </a>
        </div>
        <div class="hdrge">
            <div :class="[isSign?' tpsign':'', 'tpnav']" @click="toSign">{{isSign?'已签到':'签到得金豆'}}</div>
            <div class="lg" v-if="!islogin"><router-link to="/login">登录</router-link></div>
            <div class="ui" v-else><router-link to="/my"></router-link></div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: "Header",
    data(){
        return {
            islogin: false,
            isSign: false,
            footerList: [
                {
                    id: 1,
                    name: '首页',
                    url: '/'
                },
                {
                    id: 2,
                    name: '赛事推介',
                    url: '/recommend'
                },
                {
                    id: 3,
                    name: '专家排行',
                    url: '/rank'
                },
                {
                    id: 6,
                    name: '精选单场',
                    url: '/news'
                },
                {
                    id: 3,
                    name: '比分赔率',
                    url: '/bifen'
                },
                {
                    id: 4,
                    name: '帮助中心',
                    url: '/help'
                },
            ]
        }
    },
    watch: {
        '$store.state.token': {
            handler(v) {
                if(v === null || v === undefined || v === '')
                    this.islogin = false
                else
                    this.islogin = true
            }
        },
        // '$route': {
        //     handler(v) {
        //         console.log(v)
        //     }
        // }
    },
    mounted() {
        let that = this, token = that.$store.state.token
        if(token === null || token === '' || token === undefined){
            return
        }
        that.islogin = true
    },
    methods: {
        toSign: function () {
            if (this.isSign)
                return
            let token = this.$store.state.token, that = this
            if(token === null || token === '' || token === undefined){
                this.$toast({message: '请登录'})
            }
            else {
                this.$toast.loading()
                this.$post(that.$api.sign).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        that.isSign = true
                    }
                    else {
                        that.$toast.fail(res.msg)
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
</style>